import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import AutocompleteDropdown from './AutocompleteDropdown';
import GambitsAutocomplete from '../utils/GambitsAutocomplete';
/**
 * This is an autocomplete component not related to the SearchModal forum components.
 * It is a standalone component that can be reused for search inputs of any other types
 * of resources. It will display a dropdown menu under the input with gambit suggestions
 * similar to the SearchModal component.
 */
export default class GambitsAutocompleteDropdown extends AutocompleteDropdown {
  constructor() {
    super(...arguments);
    _defineProperty(this, "gambitsAutocomplete", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.gambitsAutocomplete = new GambitsAutocomplete(this.attrs.resource, () => this.inputElement(), this.attrs.onchange, this.attrs.onchange);
  }
  suggestions() {
    return this.gambitsAutocomplete.suggestions(this.attrs.query);
  }
}
flarum.reg.add('core', 'common/components/GambitsAutocompleteDropdown', GambitsAutocompleteDropdown);